(() => {
  const selector = '.tl-product-purchase__brand-logo';

  const removeLegacyProductBrandLogo = (scope = document) => {
    if (scope instanceof Element && scope.matches(selector)) {
      scope.remove();
      return;
    }
    scope.querySelectorAll?.(selector).forEach((element) => element.remove());
  };

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', () => removeLegacyProductBrandLogo(), { once: true });
  } else {
    removeLegacyProductBrandLogo();
  }

  document.addEventListener('shopify:section:load', (event) => {
    removeLegacyProductBrandLogo(event.target);
  });
})();
